import { useSyncExternalStore } from "react";

function subscribe(notify: () => void): () => void {
  window.addEventListener("online", notify);
  window.addEventListener("offline", notify);
  return () => {
    window.removeEventListener("online", notify);
    window.removeEventListener("offline", notify);
  };
}

function snapshot(): boolean {
  return navigator.onLine;
}

/**
 * The connectivity state as a hook: true while the browser reports a connection. The shell shows the
 * offline banner from it (features/shell/OfflineNotice.tsx); the sample data needs no connection, so
 * nothing else changes.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => true);
}
